import { useCallback } from 'react';

import { useSelector } from 'store/utils';

type ListElements = number | string | null | undefined;

export interface Trls {
    (): (key: string | undefined | null, list?: ListElements[]) => string;
}

const FALLBACK_RETURN = '';

const formatterStr = (str: string, list: string[]) =>
    str.replace(/\{(\d+)\}/g, (match: string, value: string) => list[Number(value)] || FALLBACK_RETURN);

export const translate = (
    dictionary: Record<string, string>,
    key: string | undefined | null,
    list: ListElements[] = []
): string => {
    if (!key) return FALLBACK_RETURN;

    return dictionary[key]
        ? formatterStr(
              dictionary[key],
              list.map((el) => (el || el === 0 ? el.toString() : FALLBACK_RETURN))
          )
        : FALLBACK_RETURN;
};

const useTrls: Trls = () => {
    const trls = useSelector((state) => state.translations.trls);

    return useCallback(
        (key: string | undefined | null, list: ListElements[] = []) => translate(trls, key, list),
        [trls]
    );
};

export default useTrls;
